(() => {
  const instances = new Map();
  const selector = '[data-nyxel-summary]';
  const saveLabels = {
    de: 'Sparen',
    fr: 'Économisez',
    it: 'Risparmia'
  };

  function getLocale() {
    const rawLocale = window.Shopify?.locale || document.documentElement.lang || 'en-US';
    const locale = String(rawLocale).replace('_', '-');
    const language = locale.split('-')[0].toLowerCase();
    return {
      locale: ['de', 'fr', 'it'].includes(language) ? `${language}-${language === 'de' ? 'DE' : language === 'fr' ? 'FR' : 'IT'}` : locale,
      language
    };
  }

  function parseLocalizedAmount(text) {
    if (!text) return NaN;
    const numeric = String(text).replace(/[\u00a0\u202f\s]/g, '').replace(/[^0-9.,+\-]/g, '');
    const comma = numeric.lastIndexOf(',');
    const dot = numeric.lastIndexOf('.');
    let normalized = numeric;
    if (comma >= 0 && dot >= 0) {
      const decimal = comma > dot ? ',' : '.';
      const group = decimal === ',' ? '.' : ',';
      normalized = normalized.split(group).join('').split(decimal).join('.');
    } else if (comma >= 0 || dot >= 0) {
      const separator = comma >= 0 ? ',' : '.';
      const fractionLength = numeric.length - numeric.lastIndexOf(separator) - 1;
      normalized = fractionLength === 2 ? normalized.split(separator).join('.') : normalized.split(separator).join('');
    }
    return Number(normalized);
  }

  function mount(root) {
    if (instances.has(root)) return;
    const list = root.querySelector('.UltraDetailBlock--price .ProductMeta__PriceList');
    if (!list) return;

    function refresh() {
      const prices = [...list.querySelectorAll(':scope > .Price')];
      const { locale, language } = getLocale();
      for (const price of prices) {
        const label = price.textContent.trim().replace(/\s+[A-Z]{3}\s*$/, '');
        if (price.dataset.nyxelPriceLabel !== label) price.dataset.nyxelPriceLabel = label;
      }
      const current = prices.find(price => !price.classList.contains('Price--compareAt'));
      const compare = prices.find(price => price.classList.contains('Price--compareAt'));
      const currentAmount = parseLocalizedAmount(current?.textContent);
      const compareAmount = parseLocalizedAmount(compare?.textContent);
      const saving = Math.round((compareAmount - currentAmount) * 100) / 100;
      let badge = list.querySelector('.NyxelSummarySavings');

      if (!current || !compare || !Number.isFinite(saving) || saving <= 0) {
        if (badge) badge.remove();
        return;
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'NyxelSummarySavings';
        list.append(badge);
      }

      const currency = window.Shopify?.currency?.active || 'EUR';
      const formatted = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: Number.isInteger(saving) ? 0 : 2,
        maximumFractionDigits: 2
      }).format(saving);
      const text = `${saveLabels[language] || 'Save'} ${formatted}`;
      if (badge.textContent !== text) badge.textContent = text;
    }

    const observer = new MutationObserver(refresh);
    observer.observe(list, { childList: true, subtree: true, characterData: true });
    instances.set(root, observer);
    refresh();
  }

  function initialize() { document.querySelectorAll(selector).forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, observer] of instances) {
      if (event.target.contains(root)) { observer.disconnect(); instances.delete(root); }
    }
  });
})();
